// Mirror of the export-runner's numeralFormat / formatCurrencySymbol
// (export-runner/src/lib/format.ts) so the editor preview matches the exported
// figure exactly — including a config currency override (the app-wide
// src/utils/misc numeralFormat reads the symbol from localStorage and can't take
// an override, so we replicate the few lines here to keep editor↔export parity).

function formatCurrencySymbol(currency?: string | null): string {
  const value = currency ?? '';
  if (!value) return '';
  return value.length > 1 ? `${value} ` : value;
}

function roundToSignificantFigures(num: number, n: number): number {
  if (num === 0) return 0;
  const d = Math.ceil(Math.log10(Math.abs(num)));
  const magnitude = Math.pow(10, n - d);
  return Math.round(num * magnitude) / magnitude;
}

export function formatLoss(N: number | null | undefined, currency?: string | null): string {
  const prefix = formatCurrencySymbol(currency);
  if (!N) return `${prefix}0`;
  const absN = Math.abs(N);
  const units: ReadonlyArray<readonly [number, string]> = [
    [1e12, 't'],
    [1e9, 'b'],
    [1e6, 'm'],
    [1e3, 'k'],
  ];
  for (const [value, symbol] of units) {
    if (absN >= value) return `${prefix}${roundToSignificantFigures(N / value, 3)}${symbol}`;
  }
  return `${prefix}${roundToSignificantFigures(N, 3)}`;
}
